import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, HashRouter } from 'react-router-dom';
import Home from './pages/Home';
import Submit from './pages/Submit';
import Admin from './pages/Admin';
// import Blog from './pages/Blog';
// import ContactUs from './pages/ContactUs';
// import About from './pages/About';
// import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css'; // Import global styles
import SForm from './pages/Sform';
import TForm from './pages/Tform';
import Rform from './pages/Rform';
import Banner from './components/Banner';
import Login from './components/Login';
import RFormDataList from './pages/RFormDataList';
import Vasiyat from './pages/Vasiyat';
import PPWrapper from './pages/PPWraper';
import KPWrapper from './pages/KPWraper';

const App = () => {

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  return (
    <HashRouter>
      <div className="app-container">
        <Banner />
        <main className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/submit" element={<Submit />} />
            <Route path="/login" element={isAuthenticated ? <Navigate to="/admin/*" /> : <Login onLoginSuccess={handleLoginSuccess} />} />
            <Route path="/admin/*" element={isAuthenticated ? <Admin /> : <Navigate to="/login" />} />
            <Route path="/sform" element={<SForm />} />
            <Route path="/tform" element={<TForm />} />
            <Route path="/rform" element={<Rform />} />
            <Route path="/rdata" element={<RFormDataList />} />
            <Route path="/vasiyatNaameh" element={<Vasiyat />} />
            <Route path='/post/:id' element={<PPWrapper />} />
            <Route path='/khatereh/:id' element={<KPWrapper />} />

          </Routes>
        </main>
        <Footer />
      </div>
    </HashRouter>
  );
};

export default App;
